import type { AxiosInstance, AxiosRequestConfig } from 'axios'
import type {
    IInvitationDetails,
    IPeselDetails,
    IQuestionnaireCreateResponse,
} from '@/typings/invitation'

export default (axios: AxiosInstance) => ({
    getInvitationDetails: async (token: string): Promise<IInvitationDetails> => {
        const { data } = await axios.get<IInvitationDetails>(
            `/guardian/invitation/${token}/check`,
            {
                omitAuthorization: true,
            },
        )

        return data
    },

    sendQuestionnaire: async (
        token: string,
        formData: FormData,
        config: AxiosRequestConfig = {},
    ): Promise<IQuestionnaireCreateResponse> => {
        const { data } = await axios.post<IQuestionnaireCreateResponse>(
            `/guardian/invitation/${token}/questionnaire/create`,
            formData,
            {
                ...config,
                omitAuthorization: true,
            },
        )

        return data
    },

    checkPesel: async (token: string, pesel: string): Promise<IPeselDetails> => {
        const { data } = await axios.post<IPeselDetails>(
            `/guardian/invitation/${token}/pesel/details`,
            {
                pesel,
            },
            {
                omitAuthorization: true,
            },
        )

        return data
    },
})
